import { Eye, TrendingUp, Star } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { SectionHeader } from "@/components/shared/SectionHeader";
import { GlowCard } from "@/components/shared/GlowCard";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

interface StatsSectionProps {
  stats: {
    influencerReach: string;
    averageEngagement: string;
    successfulCampaigns: string;
  };
}

export const StatsSection = ({ stats }: StatsSectionProps) => {
  const { t, language } = useLanguage();
  const { ref } = useRevealOnScroll<HTMLDivElement>();

  const statsData = [
    { icon: Eye, value: stats.influencerReach, label: t("influencerReach"), accent: "blue" as const },
    { icon: TrendingUp, value: stats.averageEngagement, label: t("averageEngagement"), accent: "violet" as const },
    { icon: Star, value: stats.successfulCampaigns, label: t("successfulCampaigns"), accent: "emerald" as const },
  ];

  return (
    <div ref={ref} className="reveal-on-scroll">
      <SectionHeader
        eyebrow={language === "ar" ? "الأرقام" : "By the numbers"}
        title={t("influencerStats")}
        subtitle={
          language === "ar"
            ? "أرقام تتحدث عن قوة شبكة المؤثرين لدينا"
            : "Numbers that speak to the power of our influencer network"
        }
        align="center"
      />
      <div className="grid grid-cols-2 gap-3 sm:gap-6 md:grid-cols-3">
        {statsData.map((s, i) => (
          <GlowCard
            key={i}
            icon={s.icon}
            accent={s.accent}
            title={<span className="text-3xl md:text-4xl tabular-nums">{s.value}</span>}
            description={s.label}
          />
        ))}
      </div>
    </div>
  );
};
